/**
 * Interpolates two latLng points by the given fraction
 *
 * @param {google.maps.latLng} from - The first latLng
 * @param {google.maps.latLng} to - The second latLng
 * @param {number} fraction - The fraction along the path
 * @return {google.maps.LatLng} The interpolated point
 */

export default function interpolate(from, to, fraction) {
  const heading = google.maps.geometry.spherical.computeHeading(from, to)
  const distance = google.maps.geometry.spherical.computeDistanceBetween(from, to)

  return google.maps.geometry.spherical.computeOffset(from, distance * fraction, heading)
}



// WEBPACK FOOTER //
// ./src/helpers/map/interpolate.js